import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

const LINES = [
  "Compiling opinions...",
  "Warming up the GPU...",
  "Asking the cat for permission...",
  "Rendering questionable life choices...",
  "Loading 10 years of ctrl+z...",
  "Negotiating with TypeScript...",
  "Spinning up the plates...",
];

// Pick once at module load — stays stable across re-renders
const PICKED = LINES[Math.floor(Math.random() * LINES.length)];
const MIN_MS = 1600;

export default function AppLoader({ children }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), MIN_MS);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <AnimatePresence>
        {loading && (
          <motion.div
            key="app-loader"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.6, ease: "easeInOut" } }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-[500] flex flex-col items-center justify-center bg-[#FAFAF7]"
            aria-live="polite"
            aria-label="Loading"
            // While fading out (loading already false) the overlay must not eat
            // clicks meant for the content underneath — the children are
            // visibility:hidden during load, so it can be non-interactive always.
            style={{ pointerEvents: "none" }}
          >
            <motion.p
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 }}
              className="font-serif italic text-[22px] sm:text-[30px] md:text-[38px] text-ink/70 text-center px-6 max-w-[22ch] leading-[1.3]"
            >
              {PICKED}
            </motion.p>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 1, 0] }}
              transition={{ duration: 1.2, delay: 0.4, repeat: Infinity, ease: "easeInOut" }}
              className="mt-6 w-2 h-2 rounded-full"
              style={{ background: "#1A1A1A", opacity: 0.4 }}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Always render children but under the loader */}
      <div style={{ visibility: loading ? "hidden" : "visible" }}>
        {children}
      </div>
    </>
  );
}
